import React from "react";
import { Button, Modal } from "antd";
import "./trainContent.scss";

const PreviewPopup = ({ isOpen, setIsOpen, description, onSubmit, pdfSelect, onCancel }) => {
  const handleOk = () => {
    setIsOpen(false);
    onCancel();
  };
  const handleCancel = () => {
    setIsOpen(false);
    onCancel();
  };
    
  const pdfUrl = React.useMemo(() => {
    return pdfSelect ? URL.createObjectURL(pdfSelect) : "";
  }, [pdfSelect]);

  return (
    <Modal
      title="Preview Content"
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width="fit-content"
      centered
      footer={
        <div className="preview-btn">
          <Button className="custom-btn" onClick={handleCancel}>
            Close
          </Button>
          <Button
            className="custom-btn"
            onClick={() => {
              onSubmit();
              setIsOpen(false);
            }}
          >
            Submit
          </Button>
        </div>
      }
    >
      <h4>Preview</h4>
      {description}
      <iframe
        height="300px"
        width="400px"
        title="Preview"
        src={pdfUrl}
      ></iframe>
    </Modal>
  );
};
export default PreviewPopup;
